import UploadFileModal from './UploadFileModal'

export default UploadFileModal